import React from "react";
import { Badge, Icon, Panel } from "@culturehq/components";
import { getQueryStringKey } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";
import { getIcon } from "constants/tagsTypes";
import { useQueryString } from "app/context";

const Announcement = ({ widget, isPreview = false, selectedOptions = [] }) => {
  const { onToggleQueryStringValue } = useQueryString();

  const handleTagClick = tag => {
    if (!isPreview) {
      onToggleQueryStringValue(getQueryStringKey(tag.entityType), tag.entity.id);
    }
  };

  return (
    <Panel className={`widget-${widget.id}`}>
      <Panel.Heading>
        {widget.title}
      </Panel.Heading>
      <Panel.Body>
        <LazyEditorOutput output={widget.body} isPreview showTags={false} />
        <div className="chq-ffd-tags">
          {!isPreview && (widget.announcementTags?.length > 0)
            && widget.announcementTags.map(tag => tag.entity && (
              <Badge key={tag.id} onClick={() => handleTagClick(tag)}>
                <Icon icon={getIcon(tag.entityType)} className="category-icon" />
                {tag.entity.name}
              </Badge>
            ))}
          {isPreview && (selectedOptions?.length > 0)
            && selectedOptions.map(option => (
              <Badge key={option.value}>
                <Icon icon={getIcon(option.category)} className="category-icon" />
                {option.label}
              </Badge>
            ))}
        </div>
      </Panel.Body>
    </Panel>
  );
};

export default Announcement;
